import { render, staticRenderFns } from "./ReturnSchool.vue?vue&type=template&id=127666f8&scoped=true"
import script from "./ReturnSchool.vue?vue&type=script&lang=js"
export * from "./ReturnSchool.vue?vue&type=script&lang=js"
import style0 from "./ReturnSchool.vue?vue&type=style&index=0&id=127666f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127666f8",
  null
  
)

export default component.exports